import { useEffect, useState } from 'react'
import Modal from '../../../components/Modal'
import useResize from '../../../hooks/useResize'
import { OUT_OF_THE_APP } from '../../../utils/constants'
import TabBar from './TabBar'
import {
  getCategories,
  getListOfSkillsCategories,
} from '../../../services/talents'
import { TAGS } from '../../../services/Tags'
import { useQuery } from '@tanstack/react-query'
import Xicon from '../../../icons/filters/Xicon'
import { CANDIDATES_TAGS } from '../../../services/Tags/candidates'
import {
  ENGLISH_LEVEL,
  EXPERIENCE_LEVEL,
} from '../../../utils/constants/filters'
import Button from '../../../components/Button'
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js'
import {
  useListOfTalentsJuniorsStore,
  useListOfTalentsStore,
  useSearchTalentsFiltersJuniorsStore,
  useSearchTalentsFiltersStore,
} from '../../../store'
import { useTranslation } from 'react-i18next'
import { getCompanySectors } from '../../../services/CompanyData'
import { getCountries } from '../../../services/Adress'
import SelectLanguages from '../../../components/SelectLanguages'
import { useForm } from 'react-hook-form'

const FiltersModal = ({
  selectedButton,
  setSelectedButton,
  handleSubmit,
  page,
  setGlobalPage,
  globalData,
  onSubmit,
  isJuniorView = false,
}) => {
  const { t } = useTranslation()
  const { isOpenModal, setIsOpenModal } = useSearchTalentsFiltersStore()
  const { setData } = useListOfTalentsStore()
  const { setData: setDataJuniors } = useListOfTalentsJuniorsStore()

  const { watch, control, setValue } = useForm({
    defaultValues: {},
  })

  const selectIdiom = watch('idioms-filter')
  const {
    selectedCategories: selectedCategoriesTalent,
    setSelectedCategories: setSelectedCategoriesTalent,

    currentCategories: currentCategoriesTalent,
    setCurrentCategories: setCurrentCategoriesTalent,

    filteredCategories: filteredCategoriesTalent,
    setFilteredCategories: setFilteredCategoriesTalent,

    filteredSectors: filteredSectorsTalent,
    setFilteredSectors: setFilteredSectorsTalent,

    filteredCountries: filteredCountriesTalent,
    setFilteredCountries: setFilteredCountriesTalent,

    experience: experienceTalent,
    setExperience: setExperienceTalent,

    selectedExperience: selectedExperienceTalent,
    setSelectedExperience: setSelectedExperienceTalent,

    sectors: sectorsTalent,
    setSectors: setSectorsTalent,

    selectedSectors: selectedSectorsTalent,
    setSelectedSectors: setSelectedSectorsTalent,

    countries: countriesTalent,
    setCountries: setCountriesTalent,

    selectedCountries: selectedCountriesTalent,
    setSelectedCountries: setSelectedCountriesTalent,

    skills: skillsTalent,
    setSkills: setSkillTalent,

    filteredSkills: filteredSkillsTalent,
    setFilteredSkills: setFilteredSkillsTalent,

    selectedSkills: selectedSkillsTalent,
    setSelectedSkills: setSelectedSkillsTalent,

    languages: languagesTalent,
    setLanguages: setLanguagesTalent,

    idioms: idiomsTalent,
    setIdioms: setIdiomsTalent,

    selectedLanguages: selectedLanguagesTalent,
    setSelectedLanguages: setSelectedLanguagesTalent,

    keywordGlobalValue: keywordGlobalValueTalent,
    selectedPromote,
    setSelectedPromote,
  } = useSearchTalentsFiltersStore()

  const {
    selectedCategories: selectedCategoriesJuniors,
    setSelectedCategories: setSelectedCategoriesJuniors,

    currentCategories: currentCategoriesJuniors,
    setCurrentCategories: setCurrentCategoriesJuniors,

    filteredCategories: filteredCategoriesJuniors,
    setFilteredCategories: setFilteredCategoriesJuniors,

    filteredSectors: filteredSectorsJuniors,
    setFilteredSectors: setFilteredSectorsJuniors,

    filteredCountries: filteredCountriesJuniors,
    setFilteredCountries: setFilteredCountriesJuniors,

    experience: experienceJuniors,
    setExperience: setExperienceJuniors,

    selectedExperience: selectedExperienceJuniors,
    setSelectedExperience: setSelectedExperienceJuniors,

    sectors: sectorsJuniors,
    setSectors: setSectorsJuniors,

    selectedSectors: selectedSectorsJuniors,
    setSelectedSectors: setSelectedSectorsJuniors,

    countries: countriesJuniors,
    setCountries: setCountriesJuniors,

    selectedCountries: selectedCountriesJuniors,
    setSelectedCountries: setSelectedCountriesJuniors,

    skills: skillsJuniors,
    setSkills: setSkillsJuniors,

    filteredSkills: filteredSkillsJuniors,
    setFilteredSkills: setFilteredSkillsJuniors,

    selectedSkills: selectedSkillsJuniors,
    setSelectedSkills: setSelectedSkillsJuniors,

    languages: languagesJuniors,
    setLanguages: setLanguagesJuniors,

    idioms: idiomsJuniors,
    setIdioms: setIdiomsJuniors,

    selectedLanguages: selectedLanguagesJuniors,
    setSelectedLanguages: setSelectedLanguagesJuniors,

    keywordGlobalValue: keywordGlobalValueJuniors,
    selectedPromote: selectedPromoteJuniors,
    setSelectedPromote: setSelectedPromoteJuniors,
  } = useSearchTalentsFiltersJuniorsStore()

  const isSelectedIdioms = isJuniorView ? idiomsJuniors : idiomsTalent
  const isSelectedLanguages = isJuniorView
    ? selectedLanguagesJuniors
    : selectedLanguagesTalent

  const isLanguageTabSelected = selectedButton === 3
  const hasNoSelectedLanguages = isSelectedLanguages?.length === 0
  const hasNoSelectedIdioms = !isSelectedIdioms

  const isApplyFiltersDisabled =
    isLanguageTabSelected && hasNoSelectedLanguages && !hasNoSelectedIdioms

  const canApplyLanguageFilters =
    !hasNoSelectedIdioms && !hasNoSelectedLanguages

  const selectedCategories = isJuniorView
    ? selectedCategoriesJuniors
    : selectedCategoriesTalent
  const setSelectedCategories = isJuniorView
    ? setSelectedCategoriesJuniors
    : setSelectedCategoriesTalent

  const currentCategories = isJuniorView
    ? currentCategoriesJuniors
    : currentCategoriesTalent
  const setCurrentCategories = isJuniorView
    ? setCurrentCategoriesJuniors
    : setCurrentCategoriesTalent

  const filteredCategories = isJuniorView
    ? filteredCategoriesJuniors
    : filteredCategoriesTalent
  const setFilteredCategories = isJuniorView
    ? setFilteredCategoriesJuniors
    : setFilteredCategoriesTalent

  const filteredSectors = isJuniorView
    ? filteredSectorsJuniors
    : filteredSectorsTalent
  const setFilteredSectors = isJuniorView
    ? setFilteredSectorsJuniors
    : setFilteredSectorsTalent

  const filteredCountries = isJuniorView
    ? filteredCountriesJuniors
    : filteredCountriesTalent
  const setFilteredCountries = isJuniorView
    ? setFilteredCountriesJuniors
    : setFilteredCountriesTalent

  const experience = isJuniorView ? experienceJuniors : experienceTalent
  const setExperience = isJuniorView
    ? setExperienceJuniors
    : setExperienceTalent

  const selectedExperience = isJuniorView
    ? selectedExperienceJuniors
    : selectedExperienceTalent
  const setSelectedExperience = isJuniorView
    ? setSelectedExperienceJuniors
    : setSelectedExperienceTalent

  const sectors = isJuniorView ? sectorsJuniors : sectorsTalent
  const setSectors = isJuniorView ? setSectorsJuniors : setSectorsTalent

  const selectedSectors = isJuniorView
    ? selectedSectorsJuniors
    : selectedSectorsTalent
  const setSelectedSectors = isJuniorView
    ? setSelectedSectorsJuniors
    : setSelectedSectorsTalent

  const countries = isJuniorView ? countriesJuniors : countriesTalent
  const setCountries = isJuniorView ? setCountriesJuniors : setCountriesTalent

  const selectedCountries = isJuniorView
    ? selectedCountriesJuniors
    : selectedCountriesTalent
  const setSelectedCountries = isJuniorView
    ? setSelectedCountriesJuniors
    : setSelectedCountriesTalent

  const skills = isJuniorView ? skillsJuniors : skillsTalent
  const setSkills = isJuniorView ? setSkillsJuniors : setSkillTalent
  const filteredSkills = isJuniorView
    ? filteredSkillsJuniors
    : filteredSkillsTalent
  const setFilteredSkills = isJuniorView
    ? setFilteredSkillsJuniors
    : setFilteredSkillsTalent
  const selectedSkills = isJuniorView
    ? selectedSkillsJuniors
    : selectedSkillsTalent
  const setSelectedSkills = isJuniorView
    ? setSelectedSkillsJuniors
    : setSelectedSkillsTalent

  const languages = isJuniorView ? languagesJuniors : languagesTalent
  const setLanguages = isJuniorView ? setLanguagesJuniors : setLanguagesTalent

  const idioms = isJuniorView ? idiomsJuniors : idiomsTalent

  const setIdioms = isJuniorView ? setIdiomsJuniors : setIdiomsTalent

  const selectedLanguages = isJuniorView
    ? selectedLanguagesJuniors
    : selectedLanguagesTalent

  const setSelectedLanguages = isJuniorView
    ? setSelectedLanguagesJuniors
    : setSelectedLanguagesTalent

  const selectedPromoteValue = isJuniorView
    ? selectedPromoteJuniors
    : selectedPromote
  const setSelectedPromoteValue = isJuniorView
    ? setSelectedPromoteJuniors
    : setSelectedPromote

  const keywordGlobalValue = isJuniorView
    ? keywordGlobalValueJuniors
    : keywordGlobalValueTalent

  const [searchTermCategory, setSearchTermCategory] = useState('')
  const [searchTermSkills, setSearchTermSkill] = useState('')
  const [searchTermSector, setSearchTermSector] = useState('')
  const [searchTermCountry, setSearchTermCountry] = useState('')

  const filterCategories = (categories, term) => {
    return categories.filter((category) =>
      category.name.toLowerCase().includes(term.toLowerCase())
    )
  }

  const filterSkills = (skills, term) => {
    return skills.filter((skills) =>
      skills.skill?.name.toLowerCase().includes(term.toLowerCase())
    )
  }

  const filterSectors = (sectors, term) => {
    return sectors.filter((sector) =>
      sector?.name.toLowerCase().includes(term.toLowerCase())
    )
  }

  const filterCountries = (countries, term) => {
    return countries?.filter((country) =>
      country?.name.toLowerCase().includes(term.toLowerCase())
    )
  }

  const viewportSize = useResize()

  const { data: categoriesData = [], isSuccess: isSuccessCategories } =
    useQuery([TAGS.categories], getCategories)

  const {
    data: skillsCategoriesData = [],
    isSuccess: isSuccessSkillsCategories,
  } = useQuery([CANDIDATES_TAGS.get_skills_categories], () =>
    getListOfSkillsCategories(0)
  )

  const { data: companySectorsData = [], isSuccess: isSuccessCompanySectors } =
    useQuery([TAGS.list_of_company_sectors], getCompanySectors)

  const { data: dataContries = [], isSuccess: isSuccessCountries } = useQuery(
    ['countries-test-test'],
    getCountries
  )

  const transformDataContries = dataContries?.map(({ id, country_name }) => ({
    id,
    name: country_name,
  }))

  const handleCloseModal = () => {
    const modal = bootstrap.Modal.getOrCreateInstance('#filter-modal')
    modal.hide()
  }

  const handleCategoryChange = (id) => {
    const updatedCategories = currentCategories?.map((category) => {
      if (category.id === id) {
        return { ...category, checked: !category.checked }
      }
      return category
    })

    const filtered = filterCategories(categoriesData, searchTermCategory)

    const selectedCategories = updatedCategories?.filter(
      (category) => category.checked
    )
    setSelectedCategories(selectedCategories)
    setCurrentCategories(updatedCategories)
    setFilteredCategories(filtered)
  }

  const handleDeleteCategory = (id) => {
    const updatedCategories = currentCategories?.map((category) => {
      if (category.id === id) {
        return { ...category, checked: false }
      }
      return category
    })

    const selectedCategories = updatedCategories?.filter(
      (category) => category.checked
    )
    setSelectedCategories(selectedCategories)
    setCurrentCategories(updatedCategories)
  }

  const handleSkillChange = (id) => {
    const updatedSkills = skills.map((skill) => {
      if (skill.id === id) {
        return { ...skill, checked: !skill.checked }
      }
      return skill
    })

    const filtered = filterSkills(skillsCategoriesData, searchTermSkills)

    const selectedSkills = updatedSkills.filter((skill) => skill.checked)
    setSelectedSkills(selectedSkills)
    setSkills(updatedSkills)
    setFilteredSkills(filtered)
  }

  const handleDeleteSkill = (id) => {
    const updatedSkills = skills.map((skill) => {
      if (skill.id === id) {
        return { ...skill, checked: false }
      }
      return skill
    })

    const selectedSkills = updatedSkills.filter((skill) => skill.checked)
    setSelectedSkills(selectedSkills)
    setSkills(updatedSkills)
  }

  const handleLanguagesChange = (id) => {
    const updatedLanguages = languages.map((language) => {
      if (language.id === id) {
        return { ...language, checked: !language.checked }
      }
      return language
    })

    const selectedLanguages = updatedLanguages.filter(
      (language) => language.checked
    )
    setSelectedLanguages(selectedLanguages)
    setLanguages(updatedLanguages)
  }

  const handleDeleteLanguages = (id) => {
    const updatedLanguage = languages.map((language) => {
      if (language.id === id) {
        return { ...language, checked: false }
      }
      return language
    })

    const selectedLanguage = updatedLanguage.filter(
      (language) => language.checked
    )
    setSelectedLanguages(selectedLanguage)
    setLanguages(updatedLanguage)
  }

  const handleExperienceChange = (id) => {
    const updatedExperience = experience.map((experience) => {
      if (experience.id === id) {
        return { ...experience, checked: !experience.checked }
      }
      return experience
    })

    const selectedExperience = updatedExperience.filter(
      (experience) => experience.checked
    )
    setSelectedExperience(selectedExperience)
    setExperience(updatedExperience)
  }

  const handleDeleteExperience = (id) => {
    const updatedExperience = experience.map((experience) => {
      if (experience.id === id) {
        return { ...experience, checked: false }
      }
      return experience
    })

    const selectedExperience = updatedExperience.filter(
      (experience) => experience.checked
    )
    setSelectedExperience(selectedExperience)
    setExperience(updatedExperience)
  }

  const handleSectorsChange = (id) => {
    const updatedSectors = sectors.map((sector) => {
      if (sector.id === id) {
        return { ...sector, checked: !sector.checked }
      }
      return sector
    })

    const filtered = filterSectors(companySectorsData, searchTermSector)

    const selectedSectors = updatedSectors.filter((sector) => sector.checked)
    setSelectedSectors(selectedSectors)
    setSectors(updatedSectors)
    setFilteredSectors(filtered)
  }

  const handleCountriesChange = (id) => {
    const updatedCountries = countries.map((country) => {
      if (country.id === id) {
        return { ...country, checked: !country.checked }
      }
      return country
    })

    const filtered = filterCountries(transformDataContries, searchTermCountry)

    const selectedCountries = updatedCountries.filter(
      (country) => country.checked
    )
    setSelectedCountries(selectedCountries)
    setCountries(updatedCountries)
    setFilteredCountries(filtered)
  }

  const handleDeleteSectors = (id) => {
    const updatedSectors = sectors.map((sector) => {
      if (Number(sector.id) === Number(id)) {
        return { ...sector, checked: false }
      }
      return sector
    })

    const selectedSectors = updatedSectors.filter((sector) => sector.checked)
    setSelectedSectors(selectedSectors)
    setSectors(updatedSectors)
  }

  const handleDeleteCountries = (id) => {
    const updatedCountries = countries.map((country) => {
      if (Number(country.id) === Number(id)) {
        return { ...country, checked: false }
      }
      return country
    })

    const selectedCountries = updatedCountries.filter(
      (country) => country.checked
    )
    setSelectedCountries(selectedCountries)
    setCountries(updatedCountries)
  }

  const renderCategories = (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-3">
        <input
          className="form-control"
          type="text"
          onChange={(e) => {
            const term = e.target.value
            setSearchTermCategory(term)

            const filtered = filterCategories(currentCategories, term)
            setFilteredCategories(filtered)
          }}
          value={searchTermCategory}
          placeholder={t('search_categories')}
        />
      </div>
      <div className="overflow-auto mt-3" style={{ height: '150px' }}>
        {filteredCategories?.map(({ id, name }) => (
          <div
            key={id}
            className="custom-control custom-checkbox form-check p-0"
            id={id}
            value={searchTermCategory}
          >
            <input
              className="me-2 border border-2 border-on-bg-primary mycheck"
              type="checkbox"
              value={id}
              key={id}
              checked={selectedCategories.some(
                (selectedCategory) => selectedCategory?.id === id
              )}
              onChange={() => handleCategoryChange(id)}
            />
            <label className="custom-control-label">{name}</label>
          </div>
        ))}
      </div>
      <div>
        <div className="d-flex flex-wrap mt-3 gap-1">
          {selectedCategories?.map(({ id, name }) => (
            <span
              key={id}
              className="d-flex align-items-center text-on-bg-CTA-primary-selected bg-bg-CTA-primary-selected badge rounded rounded-pill cursor-pointer"
            >
              {name}
              <div onClick={() => handleDeleteCategory(id)}>
                <Xicon className="cursor-pointer" />
              </div>
            </span>
          ))}
        </div>
      </div>
    </>
  )

  const renderSkills = (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-3">
        <input
          className="form-control"
          type="text"
          onChange={(e) => {
            const term = e.target.value
            setSearchTermSkill(term)

            const filtered = filterSkills(skills, term)
            setFilteredSkills(filtered)
          }}
          value={searchTermSkills}
          placeholder={t('skills')}
        />
      </div>
      <div className="overflow-auto" style={{ height: '150px' }}>
        {filteredSkills?.map((props) => (
          <div
            key={props?.id}
            className="custom-control custom-checkbox form-check p-0"
            id={props?.id}
          >
            <input
              className="me-2 border border-2 border-on-bg-primary mycheck"
              type="checkbox"
              checked={selectedSkills.some(
                (selectedSkill) => selectedSkill?.id === props?.id
              )}
              onChange={() => handleSkillChange(props?.id)}
            />
            <label className="custom-control-label">{props?.skill?.name}</label>
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap mt-3 gap-1 history-list-of-items">
        {selectedSkills?.map(({ id, skill }) => (
          <span
            key={id}
            className="d-flex justify-content-center align-items-center text-on-bg-CTA-primary-selected bg-bg-CTA-primary-selected badge rounded rounded-pill cursor-pointer"
          >
            {skill?.name}
            <div onClick={() => handleDeleteSkill(id)}>
              <Xicon className="cursor-pointer" />
            </div>
          </span>
        ))}
      </div>
    </>
  )

  const renderLanguages = (
    <>
      <div className={`${!idioms ? 'mb-5' : ''} mt-3`}>
        <SelectLanguages
          id="selected-idioms-filter"
          control={control}
          name="idioms-filter"
          defaultValue={idioms}
        />
      </div>

      {!!idioms && (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-3 d-none">
            <input
              className="form-control"
              type="text"
              placeholder={t('languages')}
            />
          </div>
          <div className="overflow-auto mt-4" style={{ height: '150px' }}>
            {languages?.map(({ id, name }) => (
              <div
                key={id}
                className="custom-control custom-checkbox form-check p-0"
                id={id}
              >
                <input
                  className="me-2 border border-2 border-on-bg-primary mycheck"
                  type="checkbox"
                  checked={selectedLanguages.some(
                    (selectedLanguages) => selectedLanguages?.id === id
                  )}
                  onChange={() => handleLanguagesChange(id)}
                />
                <label className="custom-control-label">{name}</label>
              </div>
            ))}
          </div>
          <div className="d-flex flex-wrap mt-3 gap-1 history-list-of-items">
            {selectedLanguages?.map(({ id, name }) => (
              <span
                key={id}
                className="d-flex justify-content-center align-items-center text-on-bg-CTA-primary-selected bg-bg-CTA-primary-selected badge rounded rounded-pill cursor-pointer"
              >
                {name}
                <div onClick={() => handleDeleteLanguages(id)}>
                  <Xicon className="cursor-pointer" />
                </div>
              </span>
            ))}
          </div>
        </>
      )}
    </>
  )

  const renderExperience = (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-3">
        <input
          className="form-control"
          type="text"
          placeholder={t('experience')}
        />
      </div>
      <div className="overflow-auto" style={{ height: '150px' }}>
        {experience?.map(({ id, name }) => (
          <div
            key={id}
            className="custom-control custom-checkbox form-check p-0"
            id={id}
          >
            <input
              className="me-2 border border-2 border-on-bg-primary mycheck"
              type="checkbox"
              checked={selectedExperience.some(
                (selectedExperience) => selectedExperience?.id === id
              )}
              onChange={() => handleExperienceChange(id)}
            />
            <label className="custom-control-label">{name}</label>
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap mt-3 gap-1 history-list-of-items">
        {selectedExperience?.map(({ id, name }) => (
          <span
            key={id}
            className="d-flex justify-content-center align-items-center text-on-bg-CTA-primary-selected bg-bg-CTA-primary-selected badge rounded rounded-pill cursor-pointer"
          >
            {name}
            <div onClick={() => handleDeleteExperience(id)}>
              <Xicon className="cursor-pointer" />
            </div>
          </span>
        ))}
      </div>
    </>
  )

  const renderSectors = (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-3">
        <input
          className="form-control"
          type="text"
          placeholder={t('sector')}
          onChange={(e) => {
            const term = e.target.value
            setSearchTermSector(term)

            const filtered = filterSectors(sectors, term)
            setFilteredSectors(filtered)
          }}
          value={searchTermSector}
        />
      </div>
      <div className="overflow-auto" style={{ height: '150px' }}>
        {filteredSectors?.map(({ id, name }) => (
          <div
            key={id}
            className="custom-control custom-checkbox form-check p-0"
            id={id}
          >
            <input
              className="me-2 border border-2 border-on-bg-primary mycheck"
              type="checkbox"
              checked={selectedSectors.some(
                (selectedSectors) => selectedSectors?.id === id
              )}
              onChange={() => handleSectorsChange(id)}
            />
            <label className="custom-control-label">{name}</label>
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap mt-3 gap-1 history-list-of-items">
        {selectedSectors?.map(({ id, name }) => (
          <span
            key={id}
            className="d-flex justify-content-center align-items-center text-on-bg-CTA-primary-selected bg-bg-CTA-primary-selected badge rounded rounded-pill cursor-pointer"
          >
            {name}
            <div onClick={() => handleDeleteSectors(id)}>
              <Xicon className="cursor-pointer" />
            </div>
          </span>
        ))}
      </div>
    </>
  )

  const renderCountries = (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center mt-3 mb-3">
        <input
          className="form-control"
          type="text"
          placeholder={t('country')}
          onChange={(e) => {
            const term = e.target.value
            setSearchTermCountry(term)

            const filtered = filterCountries(countries, term)
            setFilteredCountries(filtered)
          }}
          value={searchTermCountry}
        />
      </div>
      <div className="overflow-auto" style={{ height: '150px' }}>
        {filteredCountries?.map(({ id, name }) => (
          <div
            key={id}
            className="custom-control custom-checkbox form-check p-0"
            id={id}
          >
            <input
              className="me-2 border border-2 border-on-bg-primary mycheck"
              type="checkbox"
              checked={selectedCountries.some(
                (selectedCountries) => selectedCountries?.id === id
              )}
              onChange={() => handleCountriesChange(id)}
            />
            <label className="custom-control-label">{name}</label>
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap mt-3 gap-1 history-list-of-items">
        {selectedCountries?.map(({ id, name }) => (
          <span
            key={id}
            className="d-flex justify-content-center align-items-center text-on-bg-CTA-primary-selected bg-bg-CTA-primary-selected badge rounded rounded-pill cursor-pointer"
          >
            {name}
            <div onClick={() => handleDeleteCountries(id)}>
              <Xicon className="cursor-pointer" />
            </div>
          </span>
        ))}
      </div>
    </>
  )

  const renderPromote = (
    <>
      <div className="mt-3">
        <select
          className="form-select"
          value={selectedPromoteValue || ''}
          onChange={(e) => {
            const isTalentA = e.target.value === 'talentA'
            setSelectedPromoteValue(isTalentA ? 'talentA' : e.target.value?.toLocaleLowerCase())
          }}
        >
          <option value="">Selecciona</option>
          <option value="all">Todos</option>
          <option value="tecnologia">Tecnologia</option>
          <option value="ventas">Ventas</option>
          <option value="marketing">Marketing</option>
          <option value="general">General</option>
          <option value="talentA">TalentA</option>
        </select>
      </div>
    </>
  )

  const renderFilters = {
    1: renderCategories,
    2: renderSkills,
    3: renderLanguages,
    4: renderExperience,
    5: renderSectors,
    6: renderCountries,
    7: renderPromote,
  }

  useEffect(() => {
    if (
      (isSuccessCategories && currentCategories?.length === 0) ||
      currentCategories?.length === 0
    ) {
      setFilteredCategories(
        filteredCategories?.length === 0 ? categoriesData : filteredCategories
      )
      setCurrentCategories(
        currentCategories?.length === 0 ? categoriesData : currentCategories
      )
    }
  }, [isSuccessCategories])

  useEffect(() => {
    if (
      (isSuccessSkillsCategories && skills?.length === 0) ||
      filteredSkills?.length === 0
    ) {
      setSkills(selectedSkills?.length === 0 ? skillsCategoriesData : skills)
      setFilteredSkills(
        filteredSkills?.length === 0 ? skillsCategoriesData : filteredSkills
      )
    }
  }, [isSuccessSkillsCategories])

  useEffect(() => {
    if (
      (isSuccessCompanySectors && sectors?.length === 0) ||
      filteredSectors?.length === 0
    ) {
      setSectors(selectedSectors?.length === 0 ? companySectorsData : sectors)
      setFilteredSectors(
        filteredSectors?.length === 0 ? companySectorsData : filteredSectors
      )
    }
  }, [isSuccessCompanySectors])

  useEffect(() => {
    if (
      (isSuccessCountries && countries?.length === 0) ||
      filteredCountries?.length === 0
    ) {
      setCountries(
        selectedCountries?.length === 0 ? transformDataContries : countries
      )
      setFilteredCountries(
        filteredCountries?.length === 0
          ? transformDataContries
          : filteredCountries
      )
    }
  }, [isSuccessCountries])

  useEffect(() => {
    setLanguages(ENGLISH_LEVEL)
  }, [languages])

  useEffect(() => {
    setExperience(EXPERIENCE_LEVEL)
  }, [experience])

  useEffect(() => {
    if (
      !OUT_OF_THE_APP &&
      globalData?.length === 0 &&
      keywordGlobalValue === ''
    ) {
      handleSubmit(onSubmit())
    }
  }, [])

  useEffect(() => {
    if (OUT_OF_THE_APP && globalData?.length === 0) {
      handleSubmit(onSubmit())
    }
  }, [])

  useEffect(() => {
    if (page !== 0) handleSubmit(onSubmit())
  }, [page])

  useEffect(() => {
    if (isOpenModal) {
      setIdioms(selectIdiom)
    }
  }, [selectIdiom])

  useEffect(() => {
    if (isOpenModal) {
      setValue('idioms-filter', idioms)
    }
  }, [isOpenModal])

  return (
    <Modal
      modalId="filter-modal"
      title={t('search_filters')}
      titleClassName="text-on-bg-primary fw-bolder"
    >
      <div>
        <div className="d-flex flex-column justify-content-center align-items-center gap-3">
          <TabBar
            viewportSize={viewportSize}
            selectedButton={selectedButton}
            setSelectedButton={setSelectedButton}
            t={t}
            isJuniorView={isJuniorView}
          />
        </div>
        <div className="p-1">{renderFilters[selectedButton]}</div>
        <div className="d-flex justify-content-center align-items-center gap-3">
          <Button
            className="btn-white text-on-bg-primary border border-on-bg-primary"
            type="button"
            onClick={handleCloseModal}
          >
            {t('go_back')}
          </Button>
          <Button
            type="submit"
            onClick={() => {
              if (
                isLanguageTabSelected &&
                (hasNoSelectedIdioms || hasNoSelectedLanguages)
              ) {
                handleCloseModal()
                return
              }

              isJuniorView ? setDataJuniors([]) : setData([])
              setGlobalPage(0)
              setIsOpenModal(false)
              handleCloseModal()
            }}
            disabled={isApplyFiltersDisabled}
          >
            {t('apply_filters')}
          </Button>
          {canApplyLanguageFilters && isLanguageTabSelected && (
            <Button
              className="btn-white bg-danger text-white"
              type="button"
              onClick={() => {
                if (isJuniorView) {
                  setIdiomsJuniors(null)
                  setValue('idioms-filter', null)
                  setLanguagesJuniors([])
                  setSelectedLanguagesJuniors([])
                } else {
                  setIdiomsTalent(null)
                  setValue('idioms-filter', null)
                  setLanguagesTalent([])
                  setSelectedLanguagesTalent([])
                }
              }}
            >
              limpiar filtros
            </Button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default FiltersModal
